import React from "./Projects.css"
import Mwenyewe from "../../images/mwenyewe.jpg"
import Cabage from "../../images/cabbage.jpg"
import kitunguu from "../../images/kitunguu.jpg"
import Mweny from "../../images/mwen.jpg"
import system from "../../images/system.jpg"
import AOS from "aos"
import "aos/dist/aos.css"
import { useEffect, useRef } from "react"

const Projects = () => {
  useEffect(() => {
    AOS.init({duration:2000})
  },[])
 



  return (
    <div className="projects">
      <div className="projectsContainer" >
        <div className="singleProject">
          <img src="https://ghanainsider.com/wp-content/uploads/2021/05/Borehole-Drilling-Companies-In-Ghana.jpg" alt="" className="projectsImage" />
          <hr className="projectLine" />
          <div className="projectBottom">
            <p className="projectName">Kitise Borehole</p>
          </div>
        </div>
        <div className="singleProject">
          <img src={Mweny} alt="" className="projectsImage" />
          <hr className="projectLine" />
          <div className="projectBottom">
            <p className="projectName">Mua Farm Irrigation </p>
          </div>
        </div>
        <div className="singleProject">
          <img src={Cabage} alt="" className="projectsImage" />
          <hr className="projectLine" />
          <div className="projectBottom">
            <p className="projectName">Mutituni Farm</p>
          </div>
        </div>
        <div className="singleProject">
          <img src={system} alt="" className="projectsImage" />
          <hr className="projectLine" />
          <div className="projectBottom">
            <p className="projectName">Kola Solar Project</p>
          </div>
        </div>
        <div className="singleProject">
          <img src={kitunguu} alt="" className="projectsImage" />
          <hr className="projectLine" />
          <div className="projectBottom">
            <p className="projectName">Konza Irrigation</p>
          </div>
        </div>
        <div className="singleProject">
          <img src="https://tarpo.com/wp-content/uploads/2020/12/dam-liner-by-tarpo-industries-1024x768.jpeg" alt="" className="projectsImage" />
          <hr className="projectLine" />
          <div className="projectBottom">
            <p className="projectName">Mwingi Darmliners</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Projects